import { useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { updateTokens } from "../../auth/authSlice";
import { refreshTokens } from "../../api/auth.api";

const RefreshTokenView: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const performRefresh = useCallback(
    async (token?: string) => {
      const tokenToUse = token || localStorage.getItem("urlToken");

      if (!tokenToUse) {
        window.location.href = "https://login.intranetsonrie.site/";
        return;
      }

      try {
        const { accessToken, refreshToken, decodedToken } = await refreshTokens(tokenToUse);
        
        dispatch(
          updateTokens({
            accessToken,
            refreshToken,
            user: decodedToken,
          })
        );
        
        navigate("/waiting-room/join");
      } catch {
       window.location.href = "https://login.intranetsonrie.site/";

      }
    },
    [dispatch, navigate]
  );

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    const refreshToken = localStorage.getItem("refreshToken");
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");

    if (tokenFromUrl) {
      localStorage.setItem("urlToken", tokenFromUrl);
      performRefresh(tokenFromUrl);
    } else if (accessToken && refreshToken) {
      performRefresh();
    } else {
      window.location.href = "https://login.intranetsonrie.site/"; // http://localhost:5176/ http://localhost:5176/
    }
  }, [location.search, performRefresh]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <h2 className="text-xl font-bold">Refrescando token...</h2>
    </div>
  );
};

export default RefreshTokenView;
